import React from 'react';
import { cn } from '../lib/utils';

export interface LevelMedalProps {
  level: number;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export default function LevelMedal({ level, className, size = 'md' }: LevelMedalProps) {
  const containerSizes = {
    xs: 'w-6 h-6 text-[8px]',
    sm: 'w-8 h-8 text-[10px]',
    md: 'w-12 h-12 text-sm',
    lg: 'w-16 h-16 text-lg',
    xl: 'w-20 h-20 text-2xl'
  };

  return (
    <div className={cn(
      "relative flex items-center justify-center shrink-0 rounded-full font-black text-white shadow-lg border-b-4",
      "bg-gradient-to-br from-slate-700 to-slate-900 border-slate-950",
      containerSizes[size],
      className
    )}>
      {level}
    </div>
  );
}
